import { useId } from 'react'
import { Dialog, Modal, ModalOverlay } from 'react-aria-components'
import { displayKeys, SHORTCUTS } from '../keys/shortcuts'
import { useShell } from '../store'

/** The `?` sheet, generated from the same table the handlers use (PRD-018 §3.11). */
export function ShortcutSheet() {
  const { sheetOpen, setSheetOpen } = useShell()
  const titleId = useId()
  if (!sheetOpen)
    return null
  const groups = [...new Set(SHORTCUTS.map(s => s.group))]
  return (
    <ModalOverlay isOpen isDismissable onOpenChange={o => setSheetOpen(o)} className="fixed inset-0 z-50 flex items-center justify-center bg-overlay/40 p-4">
      <Modal className="w-full max-w-lg rounded-xl bg-primary p-6 shadow-xl">
        <Dialog aria-labelledby={titleId} className="outline-none">
          <h2 id={titleId} className="text-lg font-semibold text-primary">Keyboard shortcuts</h2>
          <div className="mt-4 grid grid-cols-1 gap-6 sm:grid-cols-2">
            {groups.map(g => (
              <div key={g}>
                <h3 className="mb-2 text-xs font-semibold uppercase tracking-wide text-quaternary">{g}</h3>
                <ul className="flex flex-col gap-1.5">
                  {SHORTCUTS.filter(s => s.group === g).map(s => (
                    <li key={s.id} className="flex items-center justify-between gap-3 text-sm text-secondary">
                      <span>{s.label}</span>
                      <span className="flex items-center gap-1">
                        {displayKeys(s.keys).map((k, i) => k === 'then'
                          ? <span key={`then-${s.id}-${String(i)}`} className="text-xs text-quaternary">then</span>
                          : <kbd key={`${s.id}-${k}-${String(i)}`} className="rounded border border-secondary bg-secondary px-1.5 py-0.5 font-mono text-xs text-primary">{k}</kbd>)}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </Dialog>
      </Modal>
    </ModalOverlay>
  )
}
